import ArticlesApi from '../../api/Articles';
import { ERROR_TYPES } from '../../constants/ApiErrorConstants';
import Article from '../../records/ArticleRecord';
import { isPublished } from '../../utils/articleUtils';
import promisedDebounce from '../../utils/promisedDebounce';
import * as ActionTypes from '../ActionTypes';
import { showErrorNotification, showInfoNotification, showErrorNotificationWithMessage, removeNotification } from '../Notifications';
const UPDATE_BUFFER_DEBOUNCE_DELAY_MS = 500;
function articleUpdating(id, data) {
  return {
    type: ActionTypes.UPDATE_ARTICLE_PENDING,
    payload: {
      id,
      data
    }
  };
}
function articleUpdated(payload) {
  return {
    type: ActionTypes.UPDATE_ARTICLE_SUCCESS,
    payload
  };
}
function articleUpdateRequestFailed(error) {
  return {
    error,
    type: ActionTypes.UPDATE_ARTICLE_ERROR
  };
}
function updateArticleInMemory(payload) {
  return {
    type: ActionTypes.UPDATE_ARTICLE,
    payload
  };
}
const latestChanges = {};
const saveArticleUpdates = promisedDebounce((article, dispatch, getState) => {
  const {
    values: {
      hs_id: id
    }
  } = article;
  if (!id) {
    throw new Error('Article must have an id');
  }
  const data = {
    values: latestChanges[id]
  };
  const appState = getState();
  const {
    lastEditTicks,
    sessionId,
    sessionUpdateId
  } = appState.articleContentInfo;
  dispatch(articleUpdating(id, data));
  return (isPublished(article) ? ArticlesApi.updateArticleBuffer(id, data, lastEditTicks, sessionId, sessionUpdateId) : ArticlesApi.updateArticle(id, data, lastEditTicks, sessionId, sessionUpdateId)).then(response => {
    dispatch(articleUpdated(response));
    dispatch(removeNotification('updateArticle'));
  }, error => {
    const {
      responseJSON
    } = error;
    dispatch(articleUpdateRequestFailed(error));
    if (responseJSON) {
      if (ERROR_TYPES.SLUG_CONFLICT_ERROR_TYPES.includes(responseJSON.errorType)) {
        dispatch(showErrorNotificationWithMessage('updateArticle', responseJSON.message));
      } else if (responseJSON.updateErrorType && ERROR_TYPES.ARTICLE_OPTIMISTIC_LOCKING_HANDLED_TYPES.includes(responseJSON.updateErrorType)) {
        const {
          updateErrorType,
          updatedUserName
        } = responseJSON;
        const errorMessageKey = updateErrorType === 'SAME_USER_DIFFERENT_SESSION' ? 'articleUpdateConflictSameUser' : updateErrorType === 'ANOTHER_USER' ? 'articleUpdateConflictDifferentUser' : null;
        dispatch(showInfoNotification(errorMessageKey, {
          username: updatedUserName
        }));
      } else {
        dispatch(showErrorNotification('updateArticle'));
      }
    } else {
      dispatch(showErrorNotification('updateArticle'));
    }
  });
}, UPDATE_BUFFER_DEBOUNCE_DELAY_MS);
export function updateArticle(article, data) {
  const {
    values: {
      hs_id: id
    }
  } = article;
  if (!id || !data.values) {
    throw new Error('Article must have an id');
  }
  if (!latestChanges[id]) {
    latestChanges[id] = data.values;
  } else {
    latestChanges[id] = Object.assign({}, latestChanges[id], data.values);
  }
  return (dispatch, getState) => {
    dispatch(updateArticleInMemory(new Article(Object.assign({}, article, {
      values: Object.assign({}, article.values, data.values)
    }))));
    return saveArticleUpdates(article, dispatch, getState);
  };
}